'user strict';

import { createSelector } from 'reselect';

import { roles, RBAC } from '@/roles';
import { getUrlParams, getPageUsername, getPageDate } from '../app/selectors';

export const getAction = (state, { action }) => action;

export const getUsersMap = ({ users }) => users.byUsername;

export const getAllUsers = createSelector(
	[ getUsersMap ],
	(byUsername) => Object.values(byUsername)
);

export const getPageUser = createSelector(
	[ getUsersMap, getPageUsername ],
	(users, username) => users[ username ]
);

export const getLoggedInUser = ({ users }) => users.loggedInUser;

export const getUsername = ({ users }, props) => {

	const { loggedInUser } = users;

	if (loggedInUser) {
		return loggedInUser.username;
	}
};

export const getUserById = (state, props) => id =>
	state.users.byUsername[ state.users.usernameById[ id ] ];

export const makeGetUser = () => createSelector(
	[ getUsersMap, getUsername ],
	(usersMap, username) => usersMap[ username ]
);

const accessCtl = new RBAC(roles);

export const userCan = createSelector(
	[ getLoggedInUser, getAction, getUrlParams ],
	(loggedInUser, action, urlParams) => accessCtl.userCan(
		loggedInUser,
		action,
		{ loggedInUser, params: urlParams }
	)
);
